import { Injectable } from '@angular/core';
import * as fromGraphQl from './form-variants.graphql';
import { ApolloService } from '../apollo.service';
import { FormVariantInput } from '../../entities/form-variant/form-variant';

@Injectable()
export class FormVariantsService {
  constructor(private apolloService: ApolloService) {}

  public updateFormVariant(input: FormVariantInput, callback: any): void {
    this.apolloService.mutateAndExecute(fromGraphQl.UPDATE_FORM_VARIANT_MUTATION, { input }, callback);
  }

  public createFormVariant(input: FormVariantInput, callback: any): void {
    this.apolloService.mutateAndExecute(fromGraphQl.CREATE_FORM_VARIANT_MUTATION, { input }, callback);
  }

  public deleteFormVariant(id: string, callback: any): void {
    this.apolloService.mutateAndExecute(fromGraphQl.DELETE_FORM_VARIANT_MUTATION, { id }, callback);
  }
}
